export default function dataHoraFormatada(dataHora) {
  // Verifica se dataHora é uma string ou um objeto Date
  let dateObj;

  if (typeof dataHora === 'string') {
    dateObj = new Date(dataHora);
  } else if (dataHora instanceof Date) {
    dateObj = dataHora;
  } else {
    return '';
  }

  const dia = String(dateObj.getDate()).padStart(2, '0');
  const mes = String(dateObj.getMonth() + 1).padStart(2, '0'); // Mês começa do zero
  const ano = dateObj.getFullYear();
  const horas = String(dateObj.getHours()).padStart(2, '0');
  const minutos = String(dateObj.getMinutes()).padStart(2, '0');

  return `${dia}/${mes}/${ano} (${horas}:${minutos})`;
}
